module.exports = __webpack_public_path__ + "files/transparent.8ba198fc94a9d91143b38e77bc87cb34.png";